import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BorderouAutomatFilters, BorderouAutomatStats } from './borderouri-automate.interface';

@Injectable({
    providedIn: 'root'
})
export class BorderouriAutomateService {
    private token!: string;
    private httpOptions: any;

    private basePath = environment.interop.basePath;
    private baseApiPath = this.basePath + 'api/programari/nomenclatoare/borderou-automat/';

    constructor(private http: HttpClient) { }

    getList(params: any): Observable<any> {
        return this.http.post(this.baseApiPath + 'list-dt', params, this.httpOptions);
    }

    getById(id: number): Observable<any> {
        return this.http.get(this.baseApiPath + 'show/' + id, this.httpOptions);
    }

    getHtml(id: number): Observable<any> {
        return this.http.get(this.baseApiPath + 'html/' + id, {
            ...this.httpOptions,
            responseType: 'text'
        });
    }

    getStats(): Observable<any> {
        return this.http.get(this.baseApiPath + 'stats', this.httpOptions);
    }

    export(filters: BorderouAutomatFilters): Observable<Blob> {
        return this.http.post(this.baseApiPath + 'export', { filters }, {
            headers: this.httpOptions.headers,
            responseType: 'blob' as 'json'
        }) as Observable<Blob>;
    }

    downloadPdf(id: number): Observable<Blob> {
        return this.http.get(this.baseApiPath + 'download-pdf/' + id, {
            headers: this.httpOptions.headers,
            responseType: 'blob' as 'json'
        }) as Observable<Blob>;
    }

    downloadXlsx(id: number): Observable<Blob> {
        return this.http.get(this.baseApiPath + 'download-xlsx/' + id, {
            headers: this.httpOptions.headers,
            responseType: 'blob' as 'json'
        }) as Observable<Blob>;
    }

    resend(id: number): Observable<any> {
        return this.http.post(this.baseApiPath + 'resend/' + id, {}, this.httpOptions);
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
